<template>
  <section>
    <h1>{{$t('catalog.title')}}</h1>
    <vs-row vs-justify="left" vs-align="left">
      <vs-col vs-offset="1" vs-type="flex" vs-w="10">
        <router-link to="/builder">
          <vs-button color="primary">{{$t('catalog.new')}}</vs-button>
        </router-link>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-offset="1" vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
        <vs-list>
          <vs-list-item
            v-for="catalog in catalogs"
            :key="catalog.id"
            :title="catalog.title"
            :subtitle="catalog.description"
          >
            <vs-chip
              class="chip"
              color="warning"
              v-if="catalog.expired_at && !expired(catalog)"
            >Expire le {{ formatDate(catalog.expired_at) }}</vs-chip>
            <vs-chip
              class="chip"
              color="danger"
              v-if="catalog.expired_at && expired(catalog)"
            >Dépublié</vs-chip>
            <vs-button color="primary" @click="view(catalog)">{{$t('common.view')}}</vs-button>
            <vs-button color="warning" @click="modify(catalog)">{{$t('common.edit')}}</vs-button>
            <vs-button color="danger" @click="del(catalog)">{{$t('common.delete')}}</vs-button>
          </vs-list-item>
        </vs-list>
      </vs-col>
    </vs-row>
  </section>
</template>

<script>
const { VUE_APP_API_HOST, VUE_APP_VIEWER_HOST } = process.env

import moment from 'moment'
import Catalogs from '../mixins/Catalogs.vue'

export default {
  name: 'home',

  mixins: [Catalogs],

  data: () => ({
    catalogs: []
  }),

  beforeMount() {
    this.list()
  },

  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YY')
    },

    list() {
      this.$vs.loading({ color: 'primary' })

      this.listCatalogs().then(res => {
        if (!res.body || !res.body.success) {
          this.$vs.loading.close()
          return this.$vs.dialog({
            color: 'danger',
            title: this.$t('common.error.title'),
            text: this.$t('common.error.text')
          })
        }
        this.catalogs = res.body.catalogs
        this.$vs.loading.close()
      })
    },

    view(catalog) {
      window.open(`${VUE_APP_VIEWER_HOST}/viewer/catalogs/${catalog.id}`, '_blank')
    },

    modify(catalog) {
      this.$router.push({
        name: 'builder',
        params: { catalog }
      })
    },

    expired(catalog) {
      return moment().diff(catalog.expired_at, 'days') > 0
    },

    del(catalog) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('common.warn.sure_ttl'),
        text: this.$t('common.warn.sure_text'),
        accept: () => {
          this.$vs.loading({ color: 'primary' })
          this.deleteCatalog(catalog.id).then(() => {
            this.list()
            this.$vs.loading.close()
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.vs-list{
  margin: 20px auto;
}
.chip {
  margin-right: 30px;
  margin-top: 2px;
  opacity: 0.8;
}
.vs-list--title {
  text-align: left;
}
.vs-button {
  margin: 0 5px;
}
</style>
